import { IsNotEmpty, IsString, Matches, MaxLength, MinLength } from 'class-validator';
import { Match } from '../../utils';

export class ChallengeChangePasswordRequestDto {
    @IsNotEmpty()
    @IsString()
    @MinLength(12, { message: 'Password must be at least 12 characters long' })
    @MaxLength(100, { message: 'Password must be at most 100 characters long' })
    @Matches(/[A-Z]/, { message: 'Password must contain at least one uppercase letter' })
    @Matches(/\d/, { message: 'Password must contain at least one digit' })
    @Matches(/[^A-Za-z0-9]/, { message: 'Password must contain at least one special character' })
    newPassword: string;

    @IsNotEmpty()
    @IsString()
    @Match('newPassword', { message: 'Passwords do not match' })
    confirmPassword: string;
}
